import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector) // Auto-detects user's language
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: require('./locales/en.json') },
      tr: { translation: require('./locales/tr.json') },
      ru: { translation: require('./locales/ru.json') },
      de: { translation: require('./locales/de.json') },
      es: { translation: require('./locales/es.json') },
      fr: { translation: require('./locales/fr.json') },
      pl: { translation: require('./locales/pl.json') },
      pt: { translation: require('./locales/pt.json') },
      hu: { translation: require('./locales/hu.json') },
      zh: { translation: require('./locales/zh.json') }
      // Add more languages
    },
    fallbackLng: 'en',
    interpolation: { escapeValue: false }
  });

export default i18n;